import { Injectable } from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {Observable} from 'rxjs';
import {ModalCommentComponent} from './modals/modal-comment/modal-comment.component';
import {AuditActionResult} from './audit-action-service.service';

@Injectable({
  providedIn: 'root'
})
export class DealerActionService extends ExcTranslation {

  constructor(private excRest: ExcRestService) {
    super();
  }

  public Comment(DealerID: number, DealerUPT: string, Comment?: string) {
    const _self = this;
    const obs: Observable<AuditActionResult> = Observable.create( o => {
      ExcCoreModule.showModal(ModalCommentComponent, null, 'm', {Header: _self.getRessource('DealerComment'), Comment: Comment || null}, false).subscribe( r => {
        if (r && r.proceed === true) {
          _self.excRest.post(_self.excRest.computeUrl('DealerU_Comment', {DealerID: DealerID}), {DealerUPT: DealerUPT, DealerComment: r.Comment}, {}).subscribe(ret => {
            if (ret) {
              o.next(new DealerActionResult(DealerID, true,  ret.data[0]));
              o.complete();
            }
          });
        } else {
          o.next(new DealerActionResult(DealerID, false));
          o.complete();
        }
      });
    });
    return obs;
  }
  public InternalComment(DealerID: number, DealerUPT: string, Comment?: string) {
    const _self = this;
    const obs: Observable<AuditActionResult> = Observable.create( o => {
      ExcCoreModule.showModal(ModalCommentComponent, null, 'm', {Header: _self.getRessource('DealerInternalComment'), Comment: Comment || null}, false).subscribe( r => {
        if (r && r.proceed === true) {
          _self.excRest.post(_self.excRest.computeUrl('DealerU_InternalComment', {DealerID: DealerID}), {DealerUPT: DealerUPT, DealerInternalComment: r.Comment}, {}).subscribe(ret => {
            if (ret) {
              o.next(new DealerActionResult(DealerID, true,  ret.data[0]));
              o.complete();
            }
          });
        } else {
          o.next(new DealerActionResult(DealerID, false));
          o.complete();
        }
      });
    });
    return obs;
  }
}
export class DealerActionResult {
  public get AuditID() {
    return this._auditID;
  }

  private _auditID: number;

  public get Result() {
    return this._result;
  }

  private _result: boolean;

  public get Data() {
    return this._data;
  }

  private _data: any;

  constructor(AuditID: number, Result: boolean, Data?: any) {
    this._auditID = AuditID;
    this._result = Result;
    this._data = Data || null;
  }


}
